var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F7F224EC-A75D-4436-9A38-110652049144") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-815.000000, -373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy",
    transform: "translate(149.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(665.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/pickup-details"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#A1A5B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A1A5B3",
    x: 3,
    y: 3,
    width: 13,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A1A5B3",
    x: 3,
    y: 8,
    width: 8,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A1A5B3",
    x: 13,
    y: 8,
    width: 3,
    height: 5
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.c9612daaf29a239a9ca7e1a878785c9c.svg";
export { ForwardRef as ReactComponent };